import React from 'react';
import { Routes, Route } from 'react-router-dom';
import { Toaster } from "@/components/ui/toaster";
import { Toaster as Sonner } from "@/components/ui/sonner";
import { TooltipProvider } from "@/components/ui/tooltip";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import { BrowserRouter } from "react-router-dom";
import Index from "./pages/Index";
import NotFound from "./pages/NotFound";
import BinWashSubscriptions from "./pages/BinWashSubscriptions";
import ComingSoon from "./pages/ComingSoon";
import WhyBinWashing from "./pages/WhyBinWashing";
import GutterCleaning from "./pages/GutterCleaning";
import Pricing from "./pages/Pricing";
import Contact from "./pages/Contact";
import Auth from "./pages/Auth";
import Dashboard from "./pages/Dashboard";
import PaymentSuccess from "./pages/PaymentSuccess";
import PrivacyPolicy from "./pages/PrivacyPolicy";
import AboutUs from "./pages/AboutUs";
import GuestCheckout from "./components/GuestCheckout";
import { Header } from "./components/Header";
import { AuthProvider } from "./context/AuthContext";

// Import the test utility function - both here and in the utils file for redundancy
import { runStripeWebhookTest } from "./utils/webhookTestUtils";

// Register the function globally with a more robust approach
if (typeof window !== 'undefined') {
  // Use defineProperty for more reliable global registration
  Object.defineProperty(window, 'runStripeWebhookTest', {
    value: runStripeWebhookTest,
    writable: false,
    configurable: true
  });
  
  // Clean init without debug logging
}

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      retry: false,
      refetchOnWindowFocus: false,
    },
  },
});

const App = () => {
  return (
    <QueryClientProvider client={queryClient}>
      <TooltipProvider>
        <Toaster />
        <Sonner />
        <AuthProvider>
          <BrowserRouter>
            <Header />
            <main className="pt-4">
              <Routes>
                <Route path="/" element={<Index />} />
                <Route path="/subscriptions" element={<BinWashSubscriptions />} />
                <Route path="/pricing" element={<Pricing />} />
                <Route path="/guest-checkout" element={<GuestCheckout />} />
                <Route path="/why-bin-washing" element={<WhyBinWashing />} />
                <Route path="/gutter-cleaning" element={<GutterCleaning />} />
                <Route path="/coming-soon" element={<ComingSoon />} />
                <Route path="/about-us" element={<AboutUs />} />
                <Route path="/contact" element={<Contact />} />
                <Route path="/privacy-policy" element={<PrivacyPolicy />} />
                <Route path="/admin" element={<Auth />} />
                <Route path="/dashboard" element={<Dashboard />} />
                <Route path="/payment-success" element={<PaymentSuccess />} />
                <Route path="*" element={<NotFound />} />
              </Routes>
            </main>
          </BrowserRouter>
        </AuthProvider>
      </TooltipProvider>
    </QueryClientProvider>
  );
};

export default App;